import React from 'react';
import PropTypes from 'prop-types';

import Benefits from 'app/features/landing/productComparison/components/Product/Benefits';
import Buttons from 'app/features/landing/productComparison/components/Product/Buttons/Buttons';
import Icon from 'app/features/landing/productComparison/components/Product/Icon';
import ProductWrapper from 'app/features/landing/productComparison/components/Product/ProductWrapper';
import ProductHighlightedBlock from 'app/features/landing/productComparison/components/Product/ProductHighlightedBlock';
import Price from 'app/features/landing/productComparison/components/Product/Price';
import Tax from 'app/features/landing/productComparison/components/Product/Tax';
import Title from 'app/features/landing/productComparison/components/Product/Title';
import Duration from 'app/features/landing/productComparison/components/Product/Duration';
import OtherOptionsSeparator from 'app/features/landing/productComparison/components/Product/OtherOptionsSeparator';
import S from 'app/features/landing/productComparison/components/Product/Product.styled';
import { isFreeProduct } from 'app/features/products/selectors';
import connect from 'app/libs/connect';

const UI = ({ sku, isFree }) => (
  <ProductWrapper sku={sku}>
    <ProductHighlightedBlock sku={sku}>
      <S.Product.ContentWrapper isFree={isFree} data-t="product-content">
        <S.ProductHeading>
          <S.Product.IconWrapper isFree={isFree}>
            <Icon sku={sku} />
          </S.Product.IconWrapper>
          <S.Product.TitleWrapper>
            <Title sku={sku} />
            <Duration sku={sku} />
          </S.Product.TitleWrapper>
          <Price sku={sku} />
          <Tax sku={sku} />
          <Buttons sku={sku} />
        </S.ProductHeading>
        <S.ProductBenefits isFree={isFree}>
          <Benefits sku={sku} />
        </S.ProductBenefits>
      </S.Product.ContentWrapper>
    </ProductHighlightedBlock>
    <OtherOptionsSeparator sku={sku} />
  </ProductWrapper>
);

UI.propTypes = {
  isFree: PropTypes.bool,
  sku: PropTypes.string.isRequired,
};

UI.defaultProps = { isFree: false };

UI.displayName = 'Product';

const Product = connect({ isFree: isFreeProduct })(UI);

export { UI };

export default Product;
